<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header section matches other pages -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h1 class="card-title mb-1">Attendance Tracker</h1>
              <span class="sub-text">Monitor employee presence, check-ins, and daily shifts</span>
            </div>

            <div class="d-flex align-items-center gap-2 flex-wrap">
              <!-- Monthly Attendance Export -->
              <div class="d-flex align-items-center gap-2">
                <ng-select
                  [items]="monthOptions"
                  [(ngModel)]="exportMonth"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="false"
                  [searchable]="false"
                  style="min-width: 130px" />
                <input
                  type="number"
                  class="form-control form-control-sm"
                  style="width: 90px"
                  [(ngModel)]="exportYear"
                  [min]="2020"
                  [max]="2100" />
                <button
                  class="btn btn-soft-primary d-flex align-items-center gap-2 text-nowrap"
                  (click)="onExportMonthlyAttendance()"
                  [disabled]="isExportingMonthlyAttendance">
                  @if (isExportingMonthlyAttendance) {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Exporting...
                  } @else {
                    <i class="bi bi-file-earmark-spreadsheet"></i>
                    Export Attendance
                  }
                </button>
              </div>
            </div>
          </div>

          <!-- Modern Filters Bar -->
          <div class="bg-light p-3 border mb-4">
            <div class="row g-3 align-items-end">
              <!-- Employee Selection -->
              <div class="col-lg-3 col-md-6">
                <label class="form-label small fw-bold text-muted">Field Member</label>
                <ng-select
                  [items]="employeeList"
                  bindValue="user_id"
                  bindLabel="full_name"
                  placeholder="All Employees"
                  [(ngModel)]="filters.employeeId"
                  [clearable]="true"
                  [searchable]="true">
                  <ng-template ng-label-tmp let-item="item">{{ item.first_name }} {{ item.last_name }}</ng-template>
                  <ng-template ng-option-tmp let-item="item">{{ item.first_name }} {{ item.last_name }}</ng-template>
                </ng-select>
              </div>

              <!-- Date Range -->
              <div class="col-lg-5 col-md-6">
                <label class="form-label small fw-bold text-muted">Date Range</label>
                <div class="input-group shadow-xs">
                  <input type="date" class="form-control" [(ngModel)]="filters.fromDate" />
                  <span class="input-group-text bg-white text-muted small">to</span>
                  <input type="date" class="form-control" [(ngModel)]="filters.toDate" />
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="col-lg-4 col-md-12">
                <div class="d-flex gap-2">
                  <button class="btn btn-primary flex-grow-1" (click)="onFilterAttendance()">
                    <i class="bi bi-funnel"></i>
                    <span>Apply Filters</span>
                  </button>
                  <button class="btn btn-soft-secondary px-3" (click)="onClearFilters()" title="Reset Filters">
                    <i class="bi bi-arrow-counterclockwise"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="attendance-content-area">
            @if (isDataLoading) {
              <app-loading-spinner></app-loading-spinner>
            } @else {
              @if (isHistoryMode) {
                @if (isHistoryDataLoading) {
                  <app-loading-spinner></app-loading-spinner>
                } @else {
                  <div class="animate-fade-in">
                    <app-attendance-history [attendanceList]="attendanceList" [employeeId]="filters.employeeId!" />
                  </div>
                }
              } @else {
                <div class="row g-4 animate-fade-in">
                  <div class="col-12 col-lg-4 ps-0">
                    <div class="status-card-wrapper h-100">
                      <app-attendance-status-card
                        title="Present Now"
                        [employees]="checkInList"
                        bgColorClass="bg-success bg-opacity-10"
                        textColorClass="text-success"
                        emptyMessage="No employees are currently checked in."></app-attendance-status-card>
                    </div>
                  </div>

                  <div class="col-12 col-lg-4">
                    <div class="status-card-wrapper h-100">
                      <app-attendance-status-card
                        title="Shift Completed"
                        [employees]="checkOutList"
                        bgColorClass="bg-info bg-opacity-10"
                        textColorClass="text-info"
                        emptyMessage="No employees have checked out yet today."></app-attendance-status-card>
                    </div>
                  </div>

                  <div class="col-12 col-lg-4 pe-0">
                    <div class="status-card-wrapper h-100">
                      <app-attendance-status-card
                        title="Awaiting Check-in"
                        [employees]="yetToCheckInList"
                        bgColorClass="bg-warning bg-opacity-10"
                        textColorClass="text-warning"
                        emptyMessage="All employees have reported for duty."></app-attendance-status-card>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
